<template>
  <div class="summary-post">
    <div class="summary-images social-image-slider">
      <SocialPostImageSlider :socialPost="socialPost" location="summary"  :namespace="namespace" />
    </div>
    <div class="summary-caption">
      <div class="platforms">
        <h4>
          <i v-for="network in socialPost.social_networks" :class="`fab fa-${getSocialNetworkSlugFromId(network)} platform-indicator`"></i>
        </h4>
      </div>
      <div class="caption">
        <div class="caption-text">
          <span class="no-caption" v-if="!socialPost.caption">No caption.</span>
          <div class="caption-wrap" v-if="socialPost.caption">
            {{ socialPost.caption }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SocialPostImageSlider from "./SocialPostImageSlider";

export default {
  components: {
    SocialPostImageSlider,
  },
  props: ['socialPost', 'namespace'],
  computed: {
    ...mapGetters([
      "systemSettings",
    ]),
  },
  methods: {
    getSocialNetworkSlugFromId(network_id){
      let network = this.systemSettings.social_networks.filter(network => network.id === network_id)[0];
      return network.api_type;
    },
  },
};


</script>